module.exports = __webpack_public_path__ + "static/media/เถาะ.ff7d4d51.jpg";